import { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useSoyuzLocales } from '@spotahome/soyuz/client';

import TrustPilotLink from './TrustPilotLink';

const BUSINESS_ID = '54f74fc00000ff00057dd4e0';
const TEMPLATE_DICTIONARY = {
  mini: '53aa8807dec7e10d38f59f32',
  microStar: '5419b732fbfb950b10de65e5',
  microTrustScore: '5419b637fa0340045cd0c936',
  microButton: '5419b757fa0340045cd0c938',
  microReviewCount: '5419b6a8b0d04a076446a9ad',
  slider: '54ad5defc6454f065c28af8b'
};

export const TEMPLATE_IDS = {
  MINI: 'mini',
  MICRO_STAR: 'microStar',
  MICRO_TRUST_SCORE: 'microTrustScore',
  MICRO_BUTTON: 'microButton',
  MICRO_REVIEW_COUNT: 'microReviewCount',
  SLIDER: 'slider'
};

const TrustpilotWidget = ({
  template = 'mini',
  theme = 'light',
  onClick = null,
  className = null,
  height = 120,
  width = null
}) => {
  const { current: locale } = useSoyuzLocales();
  const ref = useRef(null);

  useEffect(() => {
    if (window.Trustpilot && ref.current) {
      window.Trustpilot.loadFromElement(ref.current, true);
    }
  }, []);

  const widthProp = width ? { 'data-style-width': width } : {};

  return (
    <div
      ref={ref}
      role="button"
      tabIndex={0}
      data-locale={locale}
      data-template-id={TEMPLATE_DICTIONARY[template]}
      data-businessunit-id={BUSINESS_ID}
      data-style-height={height}
      data-theme={theme}
      onClick={onClick}
      className={className}
      {...widthProp}
    >
      <TrustPilotLink size="small" onClick={onClick} theme={theme}>
        Trustpilot
      </TrustPilotLink>
    </div>
  );
};

TrustpilotWidget.propTypes = {
  template: PropTypes.oneOf(Object.keys(TEMPLATE_IDS)),
  theme: PropTypes.oneOf(['light', 'dark']),
  onClick: PropTypes.func,
  className: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
  locale: PropTypes.string
};

export default TrustpilotWidget;
